export const requestChangesPressContacts = {
    title: "Report Data Changes",
    text: "What should be changed about this information? Once we have our team verify the change we’ll update our system!",
    content: {
        element: "input",
        attributes: {
            placeholder: "This person's email is incorrect...",
        },
    },
    buttons: {
        cancel: "Cancel",
        confirm: {
            text: "Report",
            closeModal: false,
            value: true,
        },
    },
}

export const requestChangesOfficialsAndStaffers = {
    title: "Report Incorrect Data",
    text: "What is wrong with this information? We'll send it along to our data provider. If you're reporting information about a staffer but clicked on a legislator, make sure to include the staffer's name!",
    content: {
        element: "input",
        attributes: {
            placeholder: "This person's email is incorrect...",
        },
    },
    buttons: {
        cancel: "Cancel",
        confirm: {
            text: "Report",
            closeModal: false,
            value: true,
        },
    },
}
